<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
      title="Asignaciones"
    >
      <template v-slot:after-title>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#ac8a2e"
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                large
                color="#ac8a2e"
              >
                mdi-account-plus
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Asignando</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <validation-observer v-slot="{ handleSubmit }">
                  <form
                    id="altaliga"
                    @submit.prevent="handleSubmit(validateForm)"
                  >
                    <v-row
                      align="center"
                      justify="center"
                    >
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name='Scout' rules='required'>
                          <v-select v-model="dataForm.user_id" color="gold" :error-messages="errors" label='Scout' item-value="user.id" item-text="user.name" :items="scouts" clearable>
                            <template v-slot:item="{ attrs, item, on }">
                              <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.user.fullName" />
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </form>
                </validation-observer>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    form="altaliga"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
      <v-row
        align="end"
        justify="end"
      >
        <v-col
          cols="5"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
        <v-col
          cols="auto"
        >
          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="headline">
                ¿Realmente desea eliminar?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  Aceptar
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="asignaciones"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    props: {
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        dialog: false,
        dialogDelete: false,
        dialogItem: false,
        search: undefined,
        asignado: '',
        headers: [
          { text: 'Scout', align: 'start', sortable: true, value: 'user.fullName' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        dataForm: {
          id: '',
          pedido_mercado_id: '',
          user_id: '',
        },
        editedIndex: -1,
        asignaciones: [],
        scouts: [],
      }
    },
    computed: {
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
    },
    created () {
      this.getAsignaciones()
      this.getStaff()
    },
    methods: {

      getAsignaciones: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/asignacion_pedido_mercado/' + this.id }).then(response => { this.asignaciones = response })
      },

      getStaff: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/staff_get_scout' }).then(response => { this.scouts = response })
      },

      editItem (item) {
        this.editedIndex = this.asignaciones.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItem (item) {
        this.editedIndex = this.asignaciones.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialogDelete = true
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm: async function () {
        await this.$http.delete('/api/asignacion_pedido_mercado/' + this.dataForm.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Asignación eliminada'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getAsignaciones()
        this.closeDelete()
      },

      saveAsignacion: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        this.dataForm.pedido_mercado_id = this.id
        await this.$http({
          method: method,
          url: '/api/asignacion_pedido_mercado_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Scout asignado'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getAsignaciones()
        this.close()
      },

      validateForm (scope) {
        this.saveAsignacion()
      },

    },
  }
</script>
